import { Button } from 'antd';
import { useTranslation } from 'react-i18next';

interface ButtonListTypes {
  loading?: boolean;
  btnCancelText?: string;
  btnOkText?: string;
  onCancel?: () => void;
  onOk?: () => void;
  extendChildren?: React.ReactNode;
  hiddenOKButton?: boolean;
  hiddenCancelButton?: boolean;
  isShowButton?: boolean;
}

export default function ButtonList({
  onCancel,
  onOk,
  loading,
  btnCancelText,
  btnOkText,
  extendChildren,
  hiddenCancelButton,
  hiddenOKButton,
  isShowButton = true,
}: ButtonListTypes) {
  const { t } = useTranslation();
  return (
    <div className="flex gap-[20px]">
      {isShowButton && (
        <>
          {!hiddenCancelButton && (
            <Button
              disabled={loading}
              onClick={onCancel}
              className="btn-light btn-h-32 flex-1"
            >
              {btnCancelText || t('common.button.cancel')}
            </Button>
          )}
          {!hiddenOKButton && (
            <Button
              loading={loading}
              onClick={onOk}
              type="primary"
              className="btn-h-32 flex-1"
            >
              {btnOkText || t('common.button.ok')}
            </Button>
          )}
        </>
      )}
      {extendChildren}
    </div>
  );
}
